import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import Message from '../Message/Message';
import ConversationComponent from '../ConversationComonent/ConversationComponent';
import { SELECT_CONVERSATION, SEND_CONVERSATION_MESSAGE, TOGGLE_CONVERSATION_BOLD } from '../../../redux/Conversations';
import { compose } from 'redux'
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
class Conversation extends PureComponent {
  componentDidMount() {
    const { selectConversation, toggleConversationBold, selectedItemHashId, hashId } = this.props;
    if (!selectedItemHashId && hashId) {
      selectConversation(hashId);
      toggleConversationBold(hashId, false);
    }
  }
  componentWillUnmount() {
    const { selectConversation } = this.props;
    selectConversation(null);
  }
  handleMessageSend = (message) => {
    const { sendConversationMessage, selectedItemHashId } = this.props;
    sendConversationMessage(selectedItemHashId, message);
  }

  renderMessages = () => {
    const { avatarThumb, messages, t, dontLeaveEmpty } = this.props;
    if (!dontLeaveEmpty && !messages) return null;
    if (!messages || !messages.length) return <span className="no-messages">{t('no_messages')}</span>;
    return messages.map((val) => {
      const createdAt = get(val, 'created_at');
      return (
        <Message
          key={createdAt}
          body={get(val, 'body')}
          isAdmin={get(val, 'author') === 'admin'}
          createdAt={createdAt}
          avatarThumb={avatarThumb}
        />
      );
    });
  }

  render() {
    return (
      <ConversationComponent
        renderMessages={this.renderMessages}
        onMessageSend={this.handleMessageSend}
      />
    );
  }
}

Conversation.propTypes = {
  t: PropTypes.func.isRequired,
  sendConversationMessage: PropTypes.func.isRequired,
  selectConversation: PropTypes.func.isRequired,
  toggleConversationBold: PropTypes.func.isRequired,
  selectedItemHashId: PropTypes.string,
  avatarThumb: PropTypes.string,
  dontLeaveEmpty: PropTypes.bool,
  hashId: PropTypes.string,
};

Conversation.defaultProps = {
  avatarThumb: null,
  selectedItemHashId: null,
  messages: null,
  dontLeaveEmpty: null,
  hashId: null,
};

const mapStateToProps = (state) => {
  const selectedItemHashId = get(state, ['conversations', 'selectedItemHashId']);
  return {
    avatarThumb: get(state, ['userData', 'avatar_thumb']),
    selectedItemHashId,
    messages: get(state, ['conversations', 'conversations', selectedItemHashId, 'messages']),
    conversation_id: get(state, ['conversations', 'conversations', selectedItemHashId, 'id']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendConversationMessage: (hashId, message) => dispatch(SEND_CONVERSATION_MESSAGE({ hashId, message })),
    selectConversation: hashId => dispatch(SELECT_CONVERSATION({ hashId })),
    toggleConversationBold: (hashId, value) => dispatch(TOGGLE_CONVERSATION_BOLD({ hashId, value })),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withScopedTranslations('conversations'))(Conversation)
